//Componentes generales
import { useEffect, useState, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

// Alertas
import Swal from 'sweetalert2'

//Estilos
import { PRINCIPAL, NAVBARS,COLOR_BOTONES} from '../../constants/colors';

//Contextos
import tareaContext from '../../context/tareaContext/tareaContex';
import './FormTarea.css';

/*
    Componente encargado de mostrar el formulario de usuario.
        Donde data es el usuario crear/modificar.
              minimizar es la función encargada de ocultar el dialogo.
              generar es la función del context que guarda el usuario.
              titulo es la que determina que texto mostrar en encabezado del dialogo.
              verficaUser es la función del context que comprueba la licencia por usuario vigente del cliente.
*/
function FormTarea({data, setData, minimizar, nuevoEditado, formDato, handleChangeTareas, index, generar = () => console.log("Generando"), listaUsuarios = [], tDocID = '' }){
    
    const tContext = useContext(tareaContext);
    const {agregarTarea, actualizarTareaLista, modificarTarea, eliminarTarea} = tContext;

    //State de usuario. Si no viene data por parametro significa que es nuevo por lo que se le asigna una estructura.
    const [tarea, setTarea] = useState({codTarea:"",name: '',descrp:""});
    
    //Constante que define el titulo que corresponde si vienen datos por parametros
    //const titulo = (data?.id === "" || data?.id ===  undefined) ? 'Agregar' : 'Modificar';
    const [titulo, setTitulo] = useState(nuevoEditado);

    //Funcion de validacion
    const validacion =  () => { 
        const newErrors = {};
        if (tarea.codTarea === '' || tarea.codTarea === undefined) return newErrors.codigo = 'El código de nivel1 debe ser colocado'
        if (tarea.name === '' || tarea.codTarea === undefined) return newErrors.nombre = 'El nombre debe ser colocado'
        if (tarea.descrp === '' || tarea.descrp === undefined) return newErrors.descrp = 'La descripción debe ser colocada'
        return '';
    };

    const handlerGenerar = async ()  => {
        
        const errorAxi = validacion();

        if ( errorAxi === "" ) {

            try {
                const dato = tarea;
                const res = await agregarTarea(dato);
    
                if (res !== null) {
                    Swal.fire({
                        title: `Se guardo una nueva Tarea`,
                        icon: 'success',
                        text: `Código: ${res.codTarea} \n Nombre: ${res.name}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizarTareaLista();
                    minimizar();
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre del Tarea",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }

        }else{
            Swal.fire({
                title: errorAxi,
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
        }  
    }

    const handlerModificar = async () => {

        const errorAxi = validacion();

        if (errorAxi === "") {
    
            try {
                const dato = {
                    id: data.id,
                    codTarea:tarea.codTarea,
                    name: tarea.name,
                    descrp: tarea.descrp,
                    showDescrp: tarea.showDescrp 
                }
                await setData(dato);
                const res = await modificarTarea(dato);

                if (res !== null) {
                    Swal.fire({
                        title: `Se modificó la Tarea`,
                        icon: 'success',
                        text: `Nombre: ${res.name}\n Código: ${res.codTarea}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizarTareaLista();
                    minimizar();
                    let tareaToChange = {id:res._id, label:res.name, value:res.codTarea, name:res.name, descrp:res.descrp, showDescrp:res.showDescrp};
                    handleChangeTareas(tareaToChange,index); //Se actualiza la tarea seteada en el mantenimiento para modificar su descripcion.
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre del Tarea",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }else{
                Swal.fire({
                    title: errorAxi,
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
        }  
    }

    const handlerEliminar = () => {
        const dato = {
            id: data.id,
            codNivel1:tarea.codNivel1,
            name: tarea.name,
            descrp: tarea.descrp 
        }

        Swal.fire({
            title: `Estas seguro que deseas eliminar esta Tarea?`,
            icon: 'warning',
            text: `Se eliminara permanentemente!`,
            showConfirmButton: true,
            showCancelButton: true, // Habilita el botón de cancelar
            confirmButtonText: 'Borrar',
            cancelButtonText:'No, cancelar',
            allowEnterKey: true

        }).then(async (result) => {
            if (result.isConfirmed) {
              // El usuario hizo clic en "Aceptar"
                const id = data.id
                const resp = await eliminarTarea(id, tDocID);
                console.log("resp al eliminarTarea");
                console.log(resp);
                if(resp.data.delete){
                    Swal.fire({
                        title: `Borrado!`,
                        icon: 'success',
                        text: `La Tarea fue borrada correctamente!`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                    actualizarTareaLista();
                    handleChangeTareas({},index);
                    minimizar(null);
                }else{
                    Swal.fire({
                        title: `Operacion no puede realizarse`,
                        icon: 'error',
                        text: `${resp.data.msg}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                }
            } else if (result.isDismissed) {
             // El usuario hizo clic en "Cancelar" o en cualquier otro lugar fuera del diálogo
                minimizar();
            }
        });
    }

    useEffect(()=>{
        if(data !== undefined){
            //Se crea codigoTarea ya que habia diferencias en el nombre de la propiedad cuando llegaba desde editarProcedimiento que cuando se agregaba una tarea nueva y se editaba.
            let codigoTarea = (data.codTarea != undefined) ? data.codTarea : data.value;
            let tareaModelada = {id:data?.tareaID, codTarea:codigoTarea, name: data?.name, descrp:data?.descrp, showDescrp:data?.showDescrp};
            setTarea(tareaModelada);
        }
    },[data])
    return (
        <div className='container-group-form'>
            <div className='title-form-group' style={{backgroundColor: PRINCIPAL, color:NAVBARS}}>
                {titulo} Tarea
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Codigo de Tarea: </div>
                <input disabled={ titulo === "Modificar"} value={tarea.codTarea} className='label-form-group-data' onChange={data => setTarea({ ...tarea, ['codTarea']:data.target.value })} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Nombre: </div>
                <input value={tarea.name} className='label-form-group-data' onChange={data => setTarea({ ...tarea, ['name']: data.target.value })} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Descripción: </div>
                <textarea className='label-form-group-data' value={tarea.descrp} onChange={data => setTarea({ ...tarea, ['descrp']: data.target.value })}/>
                <label style={{fontWeight:500}}>Descripción como alerta en ODT <span style={{color:'blue'}}>!!</span> <input id='checkboxShowDescrp' checked={tarea.showDescrp} type='checkbox' onChange={e => setTarea({...tarea, showDescrp: e.target.checked})}/></label>
            </div>

            <div className='container-btn-group'>
                <button className='btn-form-group' style={{backgroundColor: COLOR_BOTONES, color:NAVBARS}} onClick={( titulo !== "Modificar") ? handlerGenerar : handlerModificar}>{titulo}</button> 
                {
                    (data !== "") &&(
                        <button className='btn-eliminar-form-group' onClick={handlerEliminar}>Eliminar</button>
                    )
                }
                {
                    titulo === "Modificar" ? (
                        <button className='btn-cancel-form-group' onClick={() => minimizar(data)}>Cancelar</button>
                    ) : (
                        <button className='btn-cancel-form-group' onClick={() => minimizar()}>Cancelar</button>
                    )
                }
            </div>
        </div>
    );
}

export default FormTarea;